let branchUrl = process.env.BASE_URL
const mqttHost = process.env.VUE_APP_MQTTHOST // mqtt
const language = 'en'

export { branchUrl, mqttHost, language }
